import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';
import samplelogo from '../images/seal1.png';
import h1 from '../images/h1.png';
import h2 from '../images/h2.png';
import h3 from '../images/h3.png';
import h4 from '../images/h4.png';
import h5 from '../images/h5.png';
import h6 from '../images/h6.png';
import h7 from '../images/h7.png';
import h8 from '../images/h8.png';
import h9 from '../images/h9.png';
import h10 from '../images/h10.png';
import h11 from '../images/h11.png';
import h12 from '../images/h12.png';
const Services = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="finance-info-section">
      <div className="finance-header">
        <h2>Hot Melt <span className="highlight">Adhesive</span></h2>
      </div>
      <div className="finance-header1">
        <h2 style={{ color: 'white' }}>
          <img
            src={samplelogo} // Replace with the actual path to your uploaded image
            alt="SEALACTIVE Logo"
            className="sealactive-logo"
          />{' '}
          manufactures a wide range of EVA, Polyolefin, and pressure-sensitive hot melt adhesives for various types of applications, e.g., manual and automatic carton sealing, book binding, plywood composing, automotive parts assembly, diaper and sanitary napkin manufacturing, material lamination, paper and textiles manufacturing, air filter, furniture manufacturing and woodworking, handicrafts, etc.
        </h2>
      </div>

      <div className="finance-container">
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
            src="https://www.hotmeltpsaadhesive.com/photo/pt34951970-light_yellow_hot_melt_psa_for_medical_plaster_surgical_dressing.jpg" // Replaced with the actual path to your uploaded image
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3</h3>
            <p>
            

 
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h3} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
            src={h4} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            .
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h5}
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            .
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h6} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h7} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
           
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h8} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h9} // Replaced with the actual path to your uploaded image
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h1} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h10} // Replaced with the actual path to your uploaded image
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h11} 
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
    
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={h12} // Replaced with the actual path to your uploaded image
            alt="Hot Melt Adhesive"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>

            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;